<div class="">
  @if (totallyValidated) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13 text-accent-green">{{ totallyValidated }}</div>
    </div>
  } @else if(expired) {

      @if (totallyValidated) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-green">{{ totallyValidated }}</div>
          <!--      <svg-icon src="assets/icons/redFlag.svg"></svg-icon>-->
        </div>
      } @else {
        <div class="d-flex align-items-center gap-4">
          <div [class]="'fs-13 ' + finishedStatus.css" [attr.title]="finishedStatus.tooltip || null">{{ finishedStatus.label }}</div>
        </div>
      }


  }
  @else if (!statusCandidateAccepted) {

      @switch (data.missionStatus) {
        @case (MissionStatusEnum.PENDING) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-action">Publiée en attente</div>
          </div>
        }
        @case (MissionStatusEnum.DRAFT) {
          <div class="d-flex align-items-center align-items-center gap-2">
            <div class="fs-13 text-accent">Brouillon</div>
            <div class="d-flex gap-1 justify-content-center">
              <svg-icon src="assets/icons/edit-action.svg"
                        (click)="goTo()" class="cursor-pointer"></svg-icon>
              <svg-icon src="assets/icons/trash-red.svg" (click)="deleteMission()"
                        class="cursor-pointer"
              ></svg-icon>
            </div>
          </div>

        }
        @case (MissionStatusEnum.CANCELED) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-red">Annulée par l'etablissement</div>
          </div>
        }
        @default {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-action">En cours</div>
          </div>
        }
      }


  } @else {
    <div class="">
      @switch (statusCandidateAccepted) {
        @case (CandidatStatusOnMission.ACCEPTED) {
          @if (expired && data.missionStatus == CandidatStatusOnMission.INVALIDATED) {
            <div class="d-flex align-items-center gap-4 flex-wrap">
              <div class="fs-13 text-accent-yellow d-flex gap-2">
                <svg-icon src="assets/icons/warning.svg"></svg-icon> Validation refusée</div>
            </div>
          } @else if (expired && data.missionStatus == CandidatStatusOnMission.VALIDATED) {
            <div class="fs-13 text-accent-green">Valider</div>

          }
          @else {
            <div class="d-flex align-items-center gap-4 flex-wrap">
              <div class="fs-13 text-accent-green">Acceptée</div>
                            <app-button text="Contrat" color="accent" innerClass="cloud" [loading]="loadingContract"
                                 [tooltip]="'Générer le contrat'"
                                        (handleClick)="generateContract()"></app-button>
              <!--            <svg-icon src="assets/icons/check.svg"></svg-icon>-->
            </div>
          }
        }
        @case (CandidatStatusOnMission.PAYMENT_DONE) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Payé</div>
            <svg-icon src="assets/icons/check.svg"></svg-icon>
          </div>
        }
        @case (CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Offre totalement affectée</div>
            <div class="d-flex align-items-center gap-1">
              <svg-icon src="assets/icons/check.svg"></svg-icon>
              <svg-icon src="assets/icons/signature.svg"></svg-icon>
            </div>
          </div>
        }
        @case (CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">En attente de validation</div>
          </div>
        }
        @case (CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Validée en attente de paiement</div>
          </div>
        }
        @case (CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Validation refusée</div>
          </div>
        }

        @default {
          <div class="fs-13 text-secondary">{{ totallyValidated || '—' }}</div>
        }
      }
      <!--    <svg-icon src="assets/icons/redFlag.svg"></svg-icon>-->
      <!--    <svg-icon src="assets/icons/check.svg"></svg-icon>-->
      <!--    <svg-icon src="assets/icons/double-check.svg"></svg-icon>-->
      <!--    <svg-icon src="assets/icons/signature.svg"></svg-icon>-->
      <!--    <app-button text="Vérifier" color="accent" innerClass="cloud"></app-button>-->
      <!--    <app-button text="Publier" color="accent" innerClass="cloud"></app-button>-->
    </div>

  }

</div>
